// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Q17uq","header":"styles_header__CI3M4","row":"styles_row__HOFEu","center":"styles_center__1yFGZ"};